import { Link } from 'react-router-dom';
import { Style } from './style';
import { MobileFooterViewProps } from './type';

const MobileFooterView = ({ hook }: MobileFooterViewProps) => {
  return (
    <Style>
      <div className="footerWrap">
        <Link
          className={`${hook.location.pathname === '/manage/salemanager' && 'active'}`}
          to={'/manage/salemanager'}>
          <img
            src={`${process.env.PUBLIC_URL}/svg/ic_sidebar_pos${
              hook.location.pathname === '/manage/salemanager' ? '_active' : ''
            }.svg`}
            alt="포스아이콘"
          />
          <h3>주문접수</h3>
          {hook.fcmSalesCount > 0 && (
            <div className="countWrap">
              <p>{hook.fcmSalesCount > 99 ? '99+' : hook.fcmSalesCount}</p>
            </div>
          )}
        </Link>
        <Link
          className={`${hook.location.pathname === '/room/checkout' && 'active'}`}
          to={'/room/checkout'}>
          <img
            src={`${process.env.PUBLIC_URL}/svg/ic_sidebar_checkout${
              hook.location.pathname === '/room/checkout' ? '_active' : ''
            }.svg`}
            alt="알림아이콘"
          />
          <h3>퇴실알림</h3>
        </Link>
        {hook.useConcierge ? (
          <Link
            className={`${hook.location.pathname === '/room/request' && 'active'}`}
            to={'/room/request'}>
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_sidebar_concierge${
                hook.location.pathname === '/room/request' ? '_active' : ''
              }.svg`}
              alt="컨시어지아이콘"
            />
            <h3>고객요청</h3>
            {hook.fcmConciergeCount > 0 && (
              <div className="countWrap">
                <p>{hook.fcmConciergeCount > 99 ? '99+' : hook.fcmConciergeCount}</p>
              </div>
            )}
          </Link>
        ) : undefined}
        {hook.useInterphone ? (
          <Link
            className={`${hook.location.pathname === '/room/interphone' && 'active'}`}
            to={'/room/interphone'}>
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_sidebar_interphone${
                hook.location.pathname === '/room/interphone' ? '_active' : ''
              }.svg`}
              alt="인터폰아이콘"
            />
            <h3>인터콤</h3>
          </Link>
        ) : undefined}
      </div>
    </Style>
  );
};

export default MobileFooterView;
